import React, { useMemo, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import Projects from '../projects/Projects';
import InvoiceList from './InvoiceList';
import InvoiceGenerate from './InvoiceGenerate';
import InvoiceDetail from './InvoiceDetail';

const InvoicesPage = () => {
  const location = useLocation();
  const history = useHistory();
  const [view, setView] = useState('list'); // 'list', 'generate', 'detail'
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);

  // Extract projectid from URL
  const projectId = useMemo(
    () => new URLSearchParams(location.search).get('projectid'),
    [location.search]
  );

  const invoiceIdFromUrl = useMemo(
    () => new URLSearchParams(location.search).get('invoiceId'),
    [location.search]
  );

  // If no projectId, show the Projects selection component with correct props
  if (!projectId) {
    return <Projects navigate="membership/invoices" feature="membership" />;
  }

  const handleGenerate = () => setView('generate');
  const handleBackToList = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete('invoiceId'); // remove invoiceId from the query params
    history.push({ search: searchParams.toString() });
    setView('list');
  };
  // const handleSelectInvoice = (id) => {
  //   setSelectedInvoiceId(id);
  //   setView('detail');
  // };
  const handleBack = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete('invoiceId');
    history.push({ search: searchParams.toString() });
  };

  const handleGenerateSuccess = (id) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('invoiceId', id);
    history.push({ search: searchParams.toString() });
    setView('detail');
  };

  const handleSelectInvoice = (id) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('invoiceId', id);
    history.push({ search: searchParams.toString() });
    setView('detail');
  };

  return (
    <div className='content'>
      {view === 'list' && (
        <InvoiceList
          projectId={projectId}
          onGenerate={handleGenerate}
          onSelectInvoice={handleSelectInvoice}
        />
      )}
      {view === 'generate' && (
        <InvoiceGenerate
          projectId={projectId}
          onSuccess={handleGenerateSuccess}
          onCancel={handleBackToList}
        />
      )}
      {view === 'detail' && (
        <InvoiceDetail
          projectId={projectId}
          invoiceId={invoiceIdFromUrl}
          onBack={handleBackToList}
        />
      )}
    </div>
  );
};

export default InvoicesPage; 